import { Box, Paper } from "@mui/material";
import type { DynamicForm, FormSubmit } from "api";
import { Controller, type Control } from "react-hook-form";
import { TextBlocksRenderer } from "../TextBlocksRenderer";
import { DynamicFormSelectItem } from "./DynamicFormSelectItem";
import { DynamicFormRequiredLabel } from "./DynamicFormRequiredLabel";
import { DynamicFormErrorTooltip } from "./DynamicFormErrorTooltip";
import { DynamicFormStepHeading } from "./DynamicFormStepHeading";

type Props = {
  newsletter: DynamicForm["newsletter"];
  control: Control<FormSubmit, unknown, FormSubmit>;
};

export const DynamicFormNewsletter = (props: Props) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Box>
        <DynamicFormStepHeading>
          {props.newsletter?.title || "Newsletter"}
        </DynamicFormStepHeading>
      </Box>
      <Paper
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          p: 2,
        }}
      >
        <TextBlocksRenderer content={props.newsletter?.text} />

        <Box>
          <Controller
            control={props.control}
            rules={{
              validate: (value) =>
                value !== undefined || "This field is required",
            }}
            name="newsletterOptIn"
            render={({ field, fieldState }) => (
              <>
                <DynamicFormRequiredLabel required={true} />
                <DynamicFormErrorTooltip fieldState={fieldState} />
                <Box
                  sx={(theme) => ({
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    border: fieldState.error
                      ? `1px solid ${theme.palette.error.main}`
                      : `1px solid ${theme.palette.divider}`,
                    padding: 1,
                    borderRadius: 2,
                  })}
                  ref={field.ref}
                  id={field.name}
                >
                  <DynamicFormSelectItem
                    key={props.newsletter?.yesLabel}
                    answer={{
                      text: props.newsletter?.yesLabel ?? "Yes",
                      id: 1,
                    }}
                    checked={field.value === true}
                    disabled={field.disabled}
                    onChange={() => {
                      field.onChange(true);
                      field.onBlur();
                    }}
                  />
                  <DynamicFormSelectItem
                    key={props.newsletter?.noLabel}
                    answer={{
                      text: props.newsletter?.noLabel ?? "No",
                      id: 0,
                    }}
                    checked={field.value === false}
                    disabled={field.disabled}
                    onChange={() => {
                      field.onChange(false);
                      field.onBlur();
                    }}
                  />
                </Box>
                {/* <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  justifyContent: "space-between",
                }}
              >
                <Button
                  variant="outlined"
                  onClick={() => field.onChange(false)}
                  disabled={field.value === false}
                  color="warning"
                >
                  {props.newsletter?.noLabel || "No"}
                </Button>
                <Button
                  color="success"
                  variant="outlined"
                  onClick={() => field.onChange(true)}
                  disabled={field.value === true}
                >
                  {props.newsletter?.yesLabel || "Yes"}
                </Button>
              </Box> */}
              </>
            )}
          />
        </Box>
      </Paper>
    </Box>
  );
};
